import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTikTok = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 25.4 28.7",
	style: { enableBackground: "new 0 0 25.4 28.7" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#25F4EE;}\n	.st1{fill:#FE2C55;}\n"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M9.9,11.3v-1.1c-0.4-0.1-0.8-0.1-1.2-0.1C3.9,10.1,0,14,0,18.8c0,2.9,1.5,5.6,3.7,7.1c-1.5-1.6-2.3-3.6-2.3-5.9 C1.4,15.3,5.2,11.4,9.9,11.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M10.1,24c2.1,0,3.9-1.7,4-3.8v-19h3.5c-0.1-0.4-0.1-0.8-0.1-1.2h-4.7v19c-0.1,2.1-1.8,3.8-4,3.8 c-0.7,0-1.3-0.2-1.8-0.5C7.6,23.3,8.8,24,10.1,24z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M24,7.6v-1c-1.3,0-2.5-0.4-3.6-1.1C21.3,6.6,22.6,7.3,24,7.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M20.4,5.5c-1-1.2-1.6-2.7-1.6-4.3h-1.3C17.9,3,18.9,4.6,20.4,5.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M8.7,14.8c-2.2,0-4,1.8-4,4c0,1.5,0.9,2.9,2.1,3.5C6.3,21.6,6,20.8,6,20c0-2.2,1.8-4,4-4c0.4,0,0.8,0.1,1.2,0.2 v-4.8c-0.4-0.1-0.8-0.1-1.2-0.1c-0.1,0-0.1,0-0.2,0V15C9.5,14.9,9.1,14.8,8.7,14.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M24,7.6v3.7c-2.5,0-4.7-0.8-6.6-2.1v9.6c0,4.8-3.9,8.7-8.7,8.7c-1.9,0-3.6-0.6-5-1.6c1.6,1.7,3.9,2.8,6.4,2.8 c4.8,0,8.7-3.9,8.7-8.7v-9.6c1.9,1.3,4.1,2.1,6.6,2.1V7.8C24.9,7.8,24.4,7.7,24,7.6z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M17.4,18.8V9.2c1.9,1.3,4.1,2.1,6.6,2.1V7.6c-1.4-0.3-2.7-1.1-3.6-2.1c-1.5-1-2.5-2.5-2.9-4.3H14v19c-0.1,2.1-1.8,3.8-4,3.8 c-1.3,0-2.5-0.7-3.2-1.7c-1.3-0.7-2.1-2-2.1-3.5c0-2.2,1.8-4,4-4c0.4,0,0.8,0.1,1.2,0.2v-3.7c-4.7,0.1-8.5,4-8.5,8.7 c0,2.3,0.9,4.4,2.3,5.9c1.4,1,3.1,1.6,5,1.6C13.5,27.5,17.4,23.6,17.4,18.8z" })
	]
});
export default SvgTikTok;
